var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 410",
    style: {
      enableBackground: "new 0 0 400 410"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0.6;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_1_);enable-background:new    ;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_2_);}\r\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_3_);}\r\n\t.st3{opacity:0.702;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_4_);enable-background:new    ;}\r\n\t.st4{opacity:0.702;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_5_);enable-background:new    ;}\r\n\t.st5{opacity:0.702;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_6_);enable-background:new    ;}\r\n\t.st6{opacity:0.702;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_7_);enable-background:new    ;}\r\n\t.st7{opacity:0.8;fill-rule:evenodd;clip-rule:evenodd;fill:#16D0FF;enable-background:new    ;}\r\n\t.st8{opacity:0.8;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_8_);enable-background:new    ;}\r\n\t.st9{fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 227.4781,
    y1: 230.0351,
    x2: 336.6271,
    y2: 120.8861,
    gradientTransform: "matrix(1 0 0 -1 0 412)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03271836,
    style: {
      stopColor: "#F5F9FF",
      stopOpacity: 0.03271836
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171,
    style: {
      stopColor: "#CFE1FF",
      stopOpacity: 0.171
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3152,
    style: {
      stopColor: "#B0CEFF",
      stopOpacity: 0.3152
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4649,
    style: {
      stopColor: "#98BFFF",
      stopOpacity: 0.4649
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6224,
    style: {
      stopColor: "#86B4FF",
      stopOpacity: 0.6224
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7929,
    style: {
      stopColor: "#7CAEFF",
      stopOpacity: 0.7929
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#79ACFF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M282.1,313.6c-42.7,0-77.3-34.5-77.3-77.1s34.6-77.1,77.3-77.1s77.3,34.5,77.3,77.1S324.7,313.6,282.1,313.6z  M281.6,183.5c-30.2,0-54.7,24.4-54.7,54.6s24.5,54.6,54.7,54.6c30.2,0,54.7-24.4,54.7-54.6C336.2,207.9,311.8,183.5,281.6,183.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -1509.6954,
    y1: 11.598,
    x2: -1508.9874,
    y2: 10.89,
    gradientTransform: "matrix(175.402 0 0 131 264946.7813 -1283)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    style: {
      stopColor: "#4A82E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    style: {
      stopColor: "#428DE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3A97E2"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M117.4,124.4h175.6v131.2H117.4V124.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -1508.5161,
    y1: 12.4868,
    x2: -1507.8082,
    y2: 11.7788,
    gradientTransform: "matrix(154.367 0 0 112 232923.9375 -1249.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4983E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2B97ED"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M36.1,53.3h154.6v112.1H36.1V53.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 36.1452,
    y1: 391.2303,
    x2: 190.7384,
    y2: 391.2303,
    gradientTransform: "matrix(1 0 0 -1 0 412)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#16D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M36.1,13.3h154.6v15H36.1V13.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 17.1214,
    y1: 40.7922,
    x2: 238.8986,
    y2: 40.7922,
    gradientTransform: "matrix(1 0 0 -1 0 412)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#16D0FF"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M17.1,345.7h221.8v51.1H17.1V345.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 72.8323,
    x2: 153.1915,
    y2: 72.8323,
    gradientTransform: "matrix(1 0 0 -1 0 412)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#16D0FF"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M0,328.7h153.2v21H0V328.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 292.5657,
    y1: 58.8148,
    x2: 400,
    y2: 58.8148,
    gradientTransform: "matrix(1 0 0 -1 0 412)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#16D0FF"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M292.6,345.7H400v15H292.6V345.7z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M84.3,66.3c12.7,0,23.1,10.3,23.1,23s-10.3,23-23.1,23s-23.1-10.3-23.1-23C61.3,76.6,71.6,66.3,84.3,66.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: -1502.3854,
    y1: 20.8644,
    x2: -1501.8848,
    y2: 19.9974,
    gradientTransform: "matrix(96.232 0 0 48.0204 144645.9219 -833.5902)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4784E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    style: {
      stopColor: "#32A4ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1DC3FA"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M132.6,165.5c0-26.5-21.5-48.1-48.2-48.1s-48.2,21.5-48.2,48.1C36.1,165.5,132.6,165.5,132.6,165.5z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M142.3,184.8c-1.8,1.8-2.7,4.2-2.7,7c0,2.7,0.8,4.9,2.4,6.5c1.6,1.6,3.8,2.5,6.5,2.5c2.1,0,3.9-0.3,5.2-1 v-3.6c-1.3,0.8-2.8,1.2-4.4,1.2c-1.7,0-3.1-0.5-4.1-1.6c-1-1.1-1.5-2.5-1.5-4.3c0-1.8,0.5-3.3,1.6-4.4c1.1-1.1,2.5-1.7,4.3-1.7 c1.6,0,3,0.4,4.2,1.1v-3.7c-1.2-0.5-2.7-0.7-4.5-0.7C146.4,182,144.1,183,142.3,184.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M162.3,219.2c-1.8,0-3.2,0.8-4.2,2.4l0,0v-2.1h-3.8v13h3.8v-7.4c0-0.9,0.2-1.6,0.7-2.1 c0.5-0.6,1.1-0.8,1.8-0.8c1.5,0,2.3,1,2.3,3.1v7.2h3.8v-7.9C166.6,221,165.2,219.2,162.3,219.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M145.6,219.2c-0.7,0-1.5,0.1-2.5,0.3c-1,0.2-1.8,0.5-2.4,0.8v2.9c1.4-0.9,2.8-1.4,4.4-1.4 c1.6,0,2.4,0.8,2.4,2.3l-3.6,0.5c-3,0.4-4.5,1.9-4.5,4.3c0,1.2,0.4,2.2,1.1,2.9c0.7,0.7,1.7,1,3,1c1.7,0,3-0.7,3.9-2.2l0,0v1.9 h3.6v-7.8C151,221,149.2,219.2,145.6,219.2z M147.4,227.2c0,0.8-0.3,1.5-0.8,2s-1.1,0.8-1.9,0.8c-0.6,0-1-0.1-1.3-0.4 c-0.3-0.3-0.5-0.7-0.5-1.2c0-1.1,0.7-1.7,2.1-1.9l2.5-0.3v1H147.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M259.5,219.2c-1.8,0-3.2,0.8-4.2,2.4l0,0v-2.1h-3.8v13h3.8v-7.4c0-0.9,0.2-1.6,0.7-2.1 c0.5-0.6,1.1-0.8,1.8-0.8c1.5,0,2.3,1,2.3,3.1v7.2h3.8v-7.9C263.8,221,262.4,219.2,259.5,219.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M183.9,200.8c1.7,0,3-0.7,3.9-2.2l0,0v1.9h3.6v-7.8c0-3.6-1.8-5.4-5.4-5.4c-0.7,0-1.5,0.1-2.5,0.3 c-1,0.2-1.8,0.5-2.4,0.8v2.9c1.4-0.9,2.8-1.4,4.4-1.4c1.6,0,2.4,0.8,2.4,2.3l-3.6,0.5c-3,0.4-4.5,1.9-4.5,4.3 c0,1.2,0.4,2.2,1.1,2.9C181.7,200.5,182.6,200.8,183.9,200.8z M185.4,194.6l2.5-0.3v0.9c0,0.8-0.3,1.5-0.8,2s-1.1,0.8-1.9,0.8 c-0.6,0-1-0.1-1.3-0.4c-0.3-0.3-0.5-0.7-0.5-1.2C183.3,195.4,184,194.8,185.4,194.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M160.4,194.3c0-1.1,0.3-2.1,0.8-2.7c0.5-0.7,1.2-1,2.1-1c0.7,0,1.2,0.1,1.7,0.4v-3.5c-0.2-0.1-0.6-0.2-1-0.2 c-1.7,0-2.8,0.9-3.4,2.7l0,0v-2.4h-3.8v13h3.8v-6.3H160.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M274.7,222.4v-2.8h-3v-3.9l-3.8,1.1v2.8h-2.1v2.8h2.1v6.1c0,2.9,1.4,4.3,4.1,4.3c1.2,0,2-0.2,2.6-0.5v-2.8 c-0.5,0.3-0.9,0.4-1.3,0.4c-1.1,0-1.6-0.7-1.6-2.1v-5.5h3V222.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M226.4,219.2c-2.2,0-3.9,0.6-5.2,1.8c-1.3,1.2-1.9,2.9-1.9,5c0,2.1,0.6,3.7,1.9,4.9c1.2,1.2,2.9,1.8,5,1.8 c2.2,0,3.9-0.6,5.1-1.9c1.2-1.3,1.9-2.9,1.9-5.1c0-2-0.6-3.6-1.8-4.8C230.1,219.8,228.5,219.2,226.4,219.2z M226.3,229.9 c-2.1,0-3.2-1.3-3.2-3.9c0-1.2,0.3-2.2,0.8-2.9c0.6-0.7,1.3-1,2.3-1c2,0,3.1,1.3,3.1,3.8C229.4,228.6,228.3,229.9,226.3,229.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M208.8,221.1c-1.3,1.3-2,3-2,5.2c0,1.9,0.6,3.5,1.8,4.7c1.2,1.2,2.8,1.8,4.8,1.8c1.7,0,3-0.3,3.9-0.8v-3 c-1,0.6-1.9,1-3,1s-2-0.3-2.7-1c-0.7-0.7-1-1.6-1-2.8c0-1.2,0.4-2.2,1.1-2.9c0.7-0.7,1.6-1.1,2.8-1.1c1,0,2,0.3,2.8,1V220 c-0.7-0.4-1.8-0.6-3.3-0.6C211.9,219.2,210.2,219.9,208.8,221.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M215.2,199.8V197c-1.1,0.7-2.4,1.1-3.8,1.1c-2.3,0-3.5-1-3.6-3h8.6v-1.6c0-1.9-0.5-3.5-1.6-4.6 c-1-1.1-2.5-1.7-4.3-1.7s-3.4,0.6-4.6,1.9s-1.8,3-1.8,5c0,2.1,0.6,3.7,1.7,4.9c1.1,1.2,2.8,1.7,4.8,1.7 C212.4,200.8,214,200.5,215.2,199.8z M208.6,190.6c0.5-0.5,1.1-0.8,1.7-0.8c1.6,0,2.4,1,2.4,2.9h-5 C207.8,191.8,208.1,191.1,208.6,190.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M196.3,221.1c-1.3,1.3-2,3-2,5.2c0,1.9,0.6,3.5,1.8,4.7c1.2,1.2,2.8,1.8,4.8,1.8c1.7,0,3-0.3,3.9-0.8v-3 c-1,0.6-2,1-3,1c-1.1,0-2-0.3-2.7-1c-0.7-0.7-1-1.6-1-2.8c0-1.2,0.3-2.2,1.1-2.9c0.7-0.7,1.6-1.1,2.8-1.1c1,0,2,0.3,2.8,1V220 c-0.7-0.4-1.8-0.6-3.3-0.6C199.4,219.2,197.6,219.9,196.3,221.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M195.6,196.5c0,2.9,1.4,4.3,4.1,4.3c1.2,0,2-0.2,2.6-0.5v-2.8c-0.5,0.3-0.9,0.4-1.3,0.4 c-1.1,0-1.6-0.7-1.6-2.1v-5.5h3v-2.8h-3v-3.9l-3.8,1.1v2.8h-2.1v2.8h2.1V196.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M244.3,227c0,0.9-0.2,1.6-0.7,2.2c-0.5,0.5-1.1,0.8-1.8,0.8c-1.5,0-2.3-1-2.3-2.9v-7.5h-3.8v7.8 c0,3.6,1.5,5.5,4.5,5.5c1.7,0,3-0.8,4-2.3h0.1v2h3.8v-13h-3.8V227z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M177.2,197c-1.1,0.7-2.4,1.1-3.8,1.1c-2.3,0-3.5-1-3.6-3h8.6v-1.6c0-1.9-0.5-3.5-1.6-4.6 c-1-1.1-2.5-1.7-4.3-1.7c-1.8,0-3.4,0.6-4.6,1.9c-1.2,1.3-1.8,3-1.8,5c0,2.1,0.6,3.7,1.7,4.9c1.1,1.2,2.8,1.7,4.8,1.7 c1.9,0,3.5-0.3,4.7-1V197H177.2z M170.7,190.6c0.5-0.5,1.1-0.8,1.7-0.8c1.6,0,2.4,1,2.4,2.9h-5 C169.9,191.8,170.2,191.1,170.7,190.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M182.1,214.4l-6.7,18.2h4.2l1.3-4.2h6.6l1.4,4.2h4.2l-6.5-18.2H182.1z M181.8,225.4l2.1-6.3 c0.2-0.5,0.3-1,0.3-1.5h0.1c0.1,0.7,0.1,1.2,0.3,1.6l2.1,6.3h-4.9V225.4z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.1e37223f.svg";
export { ForwardRef as ReactComponent };